import Modalheader from "../../../components/header";
import ModalBody from "../../../components/body";
import ModalFooter from "../../../components/footer";
import Button from "../../../../button";
import useModal from "../../../useModal";
import UseContext from "hooks/useContext";
import ApiDatabase from "../../../../../server";
import {toast} from "react-toastify";
import {useState} from "react";
import useUnassignReasons from "hooks/useUnassignReasons";
import UnassignReasonForm from "../shared/UnassignReasonForm";

const AdminModalMissionUnAssign = () => {
    const {userUnAssigned, setUserUnAssigned, setModalDataReturn} = UseContext()
    const {toggle} = useModal()
    const [loading, setLoading] = useState(false)
    const unassign = useUnassignReasons(userUnAssigned?.idMission);

    const handleClose = () => {
        setUserUnAssigned({})
        unassign.reset()
        toggle()
    }

    const handleSubmit = () => {
        if (!unassign.selectedId) {
            toast.error('Veuillez sélectionner un motif de désassignation')
            return
        }
        if (unassign.noShowError) return
        if (!userUnAssigned?.idMission || !userUnAssigned?.userAssigned) {
            toast.error('Une erreur est survenue lors de la désassignation de la mission')
            return
        }
        setLoading(true)
        ApiDatabase.unassignMission({
            idMission: userUnAssigned.idMission,
            userAssigned: userUnAssigned.userAssigned,
            reason: unassign.selectedId,
            subReasons: unassign.subReasonsSelected.length > 0 ? unassign.subReasonsSelected : null
        }, () => {
            toast.success('La mission a bien été désassignée')
            setUserUnAssigned({})
            setModalDataReturn('mission unassigned')
            toggle()
        }, (err) => {
            toast.error('Une erreur est survenue lors de la désassignation de la mission : ' + err.response?.data?.error)
            setLoading(false)
        })
    }

    return (
        <>
            <Modalheader hide={handleClose} hideShow={true}>
                Désattribuer la mission
            </Modalheader>
            <ModalBody>
                {unassign.isLoading ? (
                    <div className="text-center py-4">Chargement ...</div>
                ) : (
                    <div className="flex flex-col gap-4">
                        <p>Êtes-vous sûr de vouloir dés-attribuer cette mission ?</p>
                        <UnassignReasonForm unassign={unassign} />
                    </div>
                )}
            </ModalBody>
            <ModalFooter>
                {loading ? (
                  <>
                      <Button size={'LG'} color={'DISABLED'}>Annuler</Button>
                      <Button size={'LG'} color={'DISABLED'}>Dés-attribution de la mission...</Button>
                  </>
                ) : (
                  <>
                      <Button size={'LG'} color={'SECONDARY'} onClick={handleClose}>Annuler</Button>
                      <Button size={'LG'} onClick={handleSubmit} disabled={!unassign.selectedId || !!unassign.noShowError}>Confirmer</Button>
                  </>
                )}
            </ModalFooter>
        </>
    )
}

export default AdminModalMissionUnAssign
